import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chatMessageText',
  standalone: true,
  pure: true
})
export class ChatMessageTextPipe implements PipeTransform {
  // to show string in brackets in a chat message as a clickable button

  transform(message: string) {
    if (!message) return [];

    // const regex = /\[(.*?)\]/g; //matches any text inside square brackets
    const regex = /\[\/\[(.*?)\]\/\]/g; //texts inside [/[ ]/]
    const parts: { type: 'text' | 'button'; content: string }[] = [];
    let lastIndex = 0; //moves past the current bracket so the next iteration knows where to start

    //Loop over matches
    for (const match of message.matchAll(regex)) {
      if (match.index === undefined) continue;

      // text before bracket
      if (match.index > lastIndex) {
        parts.push({ type: 'text', content: message.slice(lastIndex, match.index) });
      }
      // bracketed text as button
      parts.push({ type: 'button', content: match[1] });
      lastIndex = match.index + match[0].length;
    }

    // remaining text
    if (lastIndex < message.length) {
      parts.push({ type: 'text', content: message.slice(lastIndex) });
    }

    return parts;

  }
}
